import * as Msal from "msal";
import { authService } from "@/services";
import { IUser, IAzureBlobSettings } from "@/models";

interface IAppState {
    userAccount: Msal.Account;
    loaded: boolean;
    applicationVersion: string;
    user: IUser;
    adminUsers: IUser[];
    vipUsers: IUser[];
    blobSettings: IAzureBlobSettings;
}

const initialState: IAppState = {
    userAccount: authService.getAccount(),
    loaded: false,
    applicationVersion: null,
    user: null,
    adminUsers: null,
    vipUsers: null,
    blobSettings: null,
};

export { IAppState, initialState };
